import apiClient from "./axios.config";
import { setAuthTokens } from "../utils/authTokens";

const customerRegistration = {
  postCustomerRegistration(payload) {
    return apiClient.post("/customer/auth/register", payload);
  },

  postresendOtp(custGuid) {
    return apiClient.post(
      `/customer/auth/register/resend-otp?custGuid=${custGuid}`
    );
  },

  verifyOtp(custGuid, otp) {
    return apiClient
      .post(
        `/customer/auth/register/verify-otp?custGuid=${custGuid}&otp=${otp}`
      )
      .then((response) => {
        if (response.data && response.data.result) {
          const { accessToken, refreshToken, role } = response.data.result;
          setAuthTokens({
            accessToken,
            refreshToken,
            role: role || "C",
          });
        }
        return response;
      });
  },

  postRequestOtp(mobNo) {
    return apiClient.post(`/customer/auth/login?mobNo=${mobNo}`);
  },

  postResendOtpLogin(mobNo) {
    return apiClient.post(`/customer/auth/login/resend-otp?mobNo=${mobNo}`);
  },

  verifyOtpLogin(mobNo, otp) {
    return apiClient
      .post(`/customer/auth/login/verify-otp?mobNo=${mobNo}&otp=${otp}`)
      .then((response) => {
        if (response.data && response.data.result) {
          const { accessToken, refreshToken, role } = response.data.result;
          setAuthTokens({
            accessToken,
            refreshToken,
            role: role || "C",
          });
        }
        return response;
      })
      .catch((error) => {
        console.error("Failed to verify OTP login:", error);
        throw error;
      });
  },
};

export default customerRegistration;
